<div [ngClass]="ngDropdownClass">
  <div
    #dropdownButtonElement
    role="button"
    [ngClass]="ngButtonClass"
    tabindex="0"
    (click)="toggleDropdown()"
    (keypress)="toggleDropdown()"
  >
    @if (buttonLabel) {
      {{ buttonLabel }}
    } @else {
      <ng-content select="[dropdown-button]"></ng-content>
    }
  </div>
  <div #dropdownContentElement [ngClass]="ngContentClass">
    <ng-content select="[dropdown-content]"></ng-content>
  </div>
</div>
